export default "__VITE_ASSET__Bh7sqoff__"